import eventsWidgetSaga from './components/EventsWidget/EventsWidget.saga';

export default eventsWidgetSaga;
